import { render, staticRenderFns } from "./AlmaPharmacy.vue?vue&type=template&id=261ffc16&scoped=true"
import script from "./AlmaPharmacy.vue?vue&type=script&lang=js"
export * from "./AlmaPharmacy.vue?vue&type=script&lang=js"
import style0 from "./AlmaPharmacy.vue?vue&type=style&index=0&id=261ffc16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261ffc16",
  null
  
)

export default component.exports